<template>
  <div class="container-fluid">
    <form
          class="add-form"
          ref="profile_form"
          @submit.prevent="estimateShipping"
          @keydown.enter.prevent="() => {}"
      >
          <div class="form-wrapper full">
            <property-list-table
              @onSelectedProperties="getSelectedProperties"
              :isSelectable="displayPrintButtons"
              ref="propertyList"
              :onlyConfirmed="onlyConfirmed"
              :essentialInformations="true"
              :filterStatus="propertyStatus"
            />
          </div>
          <div class="submit-wrapper">
            <base-button
              type="button"
              class="btn btn-sm elite-submit"
              native-type="submit"
              :disabled="loading || !propertiesList.length"
            >
              <i class="fas fa-spinner fa-spin" v-if="loading"></i>
              {{ $t("COMMON.SHIP") }}
            </base-button>
          </div>
    </form>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { cloneDeep } from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
  Pagination,
  Card,
} from "element-ui";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultProperty from "../../PropertyManagement/defaultProperty";
import PropertyListTable from "../../PropertyManagement/partials/PropertyListTable.vue";
import { PROPERTY_STATUS } from "@/constants/properties";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [Card.name]: Card,
    PropertyListTable,
  },

  mixins: [alertLeave],
  props: ["user"],

  data() {
    const propertyData = this.$fillUserOrganizationData(defaultProperty);
    return {
      showModal: false,
      showEstimateModal: false,
      showEstimationsModal: false,
      loading: false,
      propertiesList: [],
      propertyStatus: 'CONFIRMED',
      PROPERTY_STATUS,
      selectedLocations: propertyData.allowedLocations,
      filterOrganizationId: this.organizationId,
      filterAuctionId: this.auctionId,
      estimateShippingContent: this.$t("PROPERTIES.ESTIMATE_SHIPPING_CONTENT"),
      totalCost: 0,
      onlyConfirmed: true,
      displayPrintButtons: true,
      estimations: [],
      estimationStatus: null,
      groupId: null,
      shipmentsListComponentKey: 0,
      PropertyListTable,
    };
  },

  created() {},

  methods: {
    async getSelectedProperties(properties) {
      this.propertiesList = properties;
    },
    async estimateShipping(){
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      try {
        if (this.propertiesList && !this.propertiesList.length) {
          this.$notify({
            type: "warning",
            message: this.$t("PROPERTIES.NO_PROPERTIES_SELECTED"),
          });
          return;
        }
        /*this.$store.dispatch("properties/estimateShippingSavedLetters", {selectedProperties : this.propertiesList});
        swal.close();
        this.$notify({
            type: 'success',
            message: this.$t('SHIPMENTS.ESTIMATION_CREATED'),
          });*/
        this.$store.dispatch("properties/estimateShippingSavedLetters", {selectedProperties : this.propertiesList});
        this.propertiesList = [];
        swal.close();
        this.$notify({
          type: "success",
          message: this.$t("SHIPMENTS.ESTIMATION_TO_CREATE"),
        });
        this.$emit("onShipmentEstimationCreated", true);
        /*if (response.data.success) {
          
          this.showEstimateModal = true;
          this.totalCost = response.data.total_cost;
          this.estimations = response.data.details;
          this.estimateShippingContent = this.$t("PROPERTIES.ESTIMATE_SHIPPING_CONTENT");
          this.estimateShippingContent = this.estimateShippingContent.replace('[TOTAL_COST]', Number(this.totalCost.toFixed(2)));
          this.groupId = response.data.group_id;
          this.propertiesList = [];
          this.shipmentsListComponentKey += 1;
          await this.$store.dispatch("elixioShipmentsEstimations/get", response.data.group_id);
          const shipmentEstimation = this.$store.getters["elixioShipmentsEstimations/elixioShipmentsEstimation"];
          this.$emit("onViewShipmentEstimation", shipmentEstimation, true);
          
        }
        swal.close();*/
        
      } catch (error) {
        swal.close();
        console.log(error);
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
      
    },
  },
};
</script>
